import { openModal } from 'utils/modal';
import { ReactComponent as Eye } from 'assets/bosta-icons/Eye.svg';

import ProductDetailsModal from '../modals/ProductDetailsModal/ProductDetailsModal';
import BRButton from 'components/BRButton/BRButton';

import './ProductDetailsModalTrigger.less';

export const ProductDetailsModalTrigger = ({ delivery, buttonLabel }) => {
  const openProductDetailsModal = () => {
    openModal(ProductDetailsModal, {
      delivery
    });
  };

  return (
    <BRButton
      type={'outline'}
      className={'br-lost-orders__product-details-modal-trigger'}
      label={buttonLabel}
      onClick={openProductDetailsModal}
      prefixIcon={<Eye />}
    />
  );
};
